import { v4 as uuidv4 } from 'uuid';
import { API_ENDPOINTS, buildApiUrl } from '../config/apiConfig';

const SESSION_ID_KEY = 'sessionId';


export function getSessionId() {
  let sessionId = localStorage.getItem(SESSION_ID_KEY);

  if (!sessionId) {
    sessionId = uuidv4();
    localStorage.setItem(SESSION_ID_KEY, sessionId);
  }

  return sessionId;
}

export async function trackVisit(path, userId = null) {
  try {
    const sessionId = getSessionId();

    await fetch(buildApiUrl(API_ENDPOINTS.TRACK_VISIT), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId, userId, path })
    });
  } catch (error) {
    console.error('❌ (Failed) to track visit:', error);
  }
}

export async function trackInteraction(questionText, answerText, sourcePage, userId = null) {
  try {
    const sessionId = getSessionId();

    // Ensure we send valid values, not empty strings
    const normalizedQuestion = questionText && questionText.trim() ? questionText.trim() : null;
    const normalizedAnswer = answerText && answerText.trim() ? answerText.trim() : null;
    const normalizedSource = sourcePage && sourcePage.trim() ? sourcePage.trim() : null;
    const normalizedUserId = userId && userId !== '' ? userId : null;

    await fetch(buildApiUrl(API_ENDPOINTS.TRACK_INTERACTION), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId,
        userId: normalizedUserId,
        questionText: normalizedQuestion,
        answerText: normalizedAnswer,
        sourcePage: normalizedSource
      })
    });
  } catch (error) {
    console.error('❌ Failed to track interaction:', error);
  }
}
